<template>
  <b-nav-item-dropdown v-if="Object.keys(locales).length > 1" size="sm">
    <template #button-content>
      {{ locales[locale] }}
    </template>
    <b-dropdown-item v-for="(value, key) in locales" :key="'locale-dropdown-key-' + key" @click.prevent="setLocale(key)">
      {{ value }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import { loadMessages } from '~/plugins/i18n'

export default {
  computed: mapGetters({
    locale: 'lang/locale',
    locales: 'lang/locales'
  }),

  methods: {
    async setLocale (locale) {
      if (this.$i18n.locale !== locale) {
        await loadMessages(locale)
        await this.$store.dispatch('lang/setLocale', { locale })
      }
    }
  }
}
</script>
